module.exports = "/static/assets/7107e149eb1e1f74e4f8fde433558d98.png";